<template>

    <v-select v-model="selected"
              :disabled=disabled
              :label=label
              :options=options
              :on-change="onSetSelected"
              :closeOnSelect=closeOnSelect
              :onSearch="onChange"
              :filterable=filterable
              :searchable=searchable
              :v-validate=validated.validate
              :class="{'is-clear': !options, 'is-loading': loading}"
              :data-vv-validate-on=validated.on
              :data-vv-name=validated.name
              :data-vv-as=validated.as>

      <slot></slot>

      <template slot="no-options">
        <div @mousedown.stop="">
          {{ noOptions }}
        </div>
      </template>

      <template slot="selected-option" slot-scope="option">
        {{getTitle(option)}}
      </template>

      <template slot="option" slot-scope="option" class="option_container">

        {{getTitle(option)}}

        <span class="load_more__button" id="load_more"
              v-if="isLastItem(option) && !isLastPage"
              @mouseover="nextPage()" @click.prevent.stop v-touch.preventDefault
              v-touch.preventDefault.tap="nextPage"><img height="24"
                                   src="../../../assets/images/loader.gif"
                                   alt="loader"></span>
      </template>

    </v-select>


</template>

<script>
  import {mapGetters} from 'vuex';
  import once from 'lodash/once';
  import debounce from 'lodash/debounce';
  export default {

    name: 'SelectWithPager',
    props: {
      options: {},
      selected: null,
      disabled: false,
      label: '',
      loading: false,
      lastId: null,
      isLastPage: false,
      header: '',
      filterable: false,
      searchable: false,
      noOptions: '',
      validated:{
        type: [Object],
        default() {
          return {
            validate: 'required:false',
            on: '',
            name: '',
            as: ''
          };
        },
      },
      getOptionTitle:{
        type: Function,
        default(option) {
          return option.title;
        },
      },
      isLast:Function,
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },

    data(){
      return {
        closeOnSelect: true,
        clickOnNext: false,
        newSelected: null
      }
    },

    created() {
      this.closeOnSelect = this.isMobile ? false : true
    },

    methods: {

      onSetSelected(selected) {

        if (selected && this.isMobile){
          if(this.clickOnNext) {
            this.closeOnSelect = false
          } else{
            this.closeOnSelect = true
          }
          this.newSelected = selected;
          this.clickOnNext = false;
        }

        this.$emit('set-selected', selected);

      },

      onChange: debounce(
        function (search) {
          this.$emit('set-search', search, this);
        }, 500
      ),


      nextPage() {
        this.clickOnNext = true;
        this.closeOnSelect = this.isMobile ? false : true
        if (!this.loading){
          this.$emit('next-page');
        }
      },

      getTitle(option){
        return this.getOptionTitle({
          option
        });
      },

      isLastItem(option){
        return this.isLast({
          option
        });
      }

    },

  };
</script>


// WEBPACK FOOTER //
// src/common/selectWithPager/components/SelectWithPager.vue